<div class="w-full h-screen flex items-center justify-center text-center p-gutter">
    <div>
        <img src="assets/puma-logo.png" alt="PUMA Logo" width="400"/>
           <p class="display-1 font-medium m-0 Txt_2">Thank you for choosing digital service!</p>
    <p class="title m-0 mt-3 max-w-2xl mx-auto">
    We appreciate your support in making communication faster, smoother, and more eco-friendly.
  </p>
    </div>
</div>
